export const config = {
    WS_URL: 'wss://dawid.elixir-luxembourg.org/ws',
    WS_USERNAME: 'dawid',
    WS_PASSWORD: 'dawid',
    EXTRA_FOOTER: '<p style="text-align: center">\n' +
        '            <span id="doNotTrack-text"><span id="gdpr-result-text">Only necessary cookies accepted</span> - <a\n' +
        '                style="" href="javascript:showBanner();">change</a></span>\n' +
        '        </p>'
};
